<script>
import Layout from "../../layouts/main";
import Heading from "../../layouts/heading";
import TeamCard from "@/components/cards/TeamCard";
import appConfig from "@/app.config";
import {
  staffMembers
} from "./data.js"
// import api from "../../../api";

export default {
  page: {
    title: "Staff Members",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
    Heading,
    TeamCard
  },
  data() {
    return {
      page: {
        title: "Staff Members",
        lastUpdated: '31 Dec 2020 15:00',
        addNewBtn: false,
        deleteBtn: false,
        activeBtn: false,
        submitBtn: false,
      },
      screenWidth: 1440,
      staffMembers: staffMembers,
      staffMembersCatId: null,
      categoriesList: [],
      activeTab: 0
    }
  },
  computed: {
    pageTabs() {
      const roles = this.staffMembers.reduce((acc, member) => {
        if (acc.includes(member.role)) return acc
        acc.push(member.role)
        return acc
      }, [])
      return roles.map(role => {
        return {
          title: role,
          name: role.split(' ').join('_').toLowerCase()
        }
      })
    },
    practiceTeam() {
      return this.pageTabs.reduce((acc, tab) => {
        acc[tab.name] = this.staffMembers.filter(member => member.role === tab.title)
        return acc
      }, {})
    }
  },
  methods: {
    
  },
  mounted() {
    if (this.$route.query && this.$route.query.tab) {
      const index = this.pageTabs.findIndex(tab => tab.name === this.$route.query.tab)
      if (index < 0) {
        return
      }
      this.activeTab = index
    }
  }
};
</script>

<template>
  <Layout>
    <Heading :page="page"></Heading>
    
    <!-- <PageTitle :img="pageData.pageTitle.img" :title="pageData.pageTitle.title" :text="pageData.pageTitle.text"/> -->
    <div class="py-4">
      <PageTabsBlock
        :tabItems="pageTabs"
        :activeTab="activeTab"
        ref="features"
      >
        <template v-for="(tab, index) of pageTabs" v-slot:[tab.name]>
          <div class="container-fluid py-4" :key="index">
            <div class="row">
              <div
                class="col-12 col-md-6 col-lg-4 col-xl-3"
                v-for="(card, i) of practiceTeam[tab.name]"
                :key="i"
              >
                <TeamCard
                  :id="card.id"
                  :name="card.title"
                  :avatar="card.picture ? card.picture : require('@/assets/images/avatar-man.svg')"
                  :title="card.role"
                  :qualification="card.email"
                  @collapse="onCardCollapse()"
                  :ref="card.id"
                ></TeamCard>
              </div>
            </div>
          </div>
        </template>
      </PageTabsBlock>
    </div>
  </Layout>
</template>
